import * as yup from 'yup';

export const schema = yup.object({
  loja_conferencia: yup.number().required(),
  dta_mov: yup.string().required(),
});
